export function MainLoader() {
  return (
    <div className="preloader dark:preloader">
      <img src="/images/dark-logo.svg" width="300" alt="StagWorks" className="dark-logo dark:dark-logo" />
      <img src="/images/light-logo.svg" width="300" alt="StagWorks" className="light-logo dark:light-logo" />
    </div>
  );
}
